import React, { Component } from 'react';
import '../../assets/css/home.css';
import Banner from "../../widget/PageBanner";


export default class ExploreTheWorld extends Component {
	constructor(props){
		super(props);
		this.state = {redirect: false};
	}
	componentDidMount = () =>{
		window.scrollTo(0, 0);
	}
	
  render() {
    return (
		<>	
			<Banner pagename="Home"/>
		</>
    );
  }
}